import React from "react";

import { Button, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import { HIDE_MODAL_LOADING } from "reducer/actions";

import Loader from "./Loader";

const ModalWrapper = ({
  show,
  hide,
  header,
  handleSubmit = null,
  children,
  size = null,
  ...options
}) => {
  const { showModalLoader } = useSelector((state) => state.utility);
  const dispatch = useDispatch();

  const handleHide = () => {
    hide();
    dispatch({ type: HIDE_MODAL_LOADING });
  };

  return (
    <Modal
      show={show}
      onHide={handleHide}
      size={size ? size : "lg"}
      {...options}
    >
      <Modal.Header closeButton>
        <Modal.Title>{header}</Modal.Title>
      </Modal.Header>
      {showModalLoader && <Loader loaderClass="modalLoading" />}
      <>
        <Modal.Body>{children}</Modal.Body>
        <Modal.Footer>
          {handleSubmit && (
            <Button variant="primary" onClick={handleSubmit}>
              Submit
            </Button>
          )}
        </Modal.Footer>
      </>
    </Modal>
  );
};

export default ModalWrapper;
